export default "__VITE_ASSET__578def93__"